import SyncBehaviourSelect, {
  ISyncBehaviourProps,
} from '@components/sources/visualizer/mappingScreens/config/syncBehaviourConfig/syncBehaviourSelect';
import useStores from '@stores/useStores';
import React from 'react';
import { getSyncBehaviourOptions } from '@components/sources/visualizer/mappingScreens/config/syncBehaviourConfig';
import classes from '@components/sources/source-view/source-schema/sync-schema.module.scss';

interface ISyncBehaviourPropsJsonMapping extends ISyncBehaviourProps {
  destSyncBehaviourOptions?: string[];
  srcSyncBehaviourOptions: string[];
}

const SyncBehaviourConfig = ({
  destSyncBehaviourOptions,
  srcSyncBehaviourOptions,
  isViewOrUpdate,
  currentMode,
  setSyncBehaviour,
}: ISyncBehaviourPropsJsonMapping) => {
  const { workspaceStore } = useStores();
  const syncBehaviourOptions = getSyncBehaviourOptions(
    workspaceStore.whActionsSyncBehaviours,
    srcSyncBehaviourOptions,
    destSyncBehaviourOptions,
  );
  return (syncBehaviourOptions.length > 0 && !isViewOrUpdate) ||
    (currentMode && workspaceStore.whActionsSyncBehaviours.includes(currentMode)) ? (
    <div className={classes.sync_behaviour_footer}>
      <SyncBehaviourSelect
        syncBehaviourOptions={syncBehaviourOptions}
        isViewOrUpdate={isViewOrUpdate}
        currentMode={currentMode}
        setSyncBehaviour={setSyncBehaviour}
      />
    </div>
  ) : null;
};
export default SyncBehaviourConfig;
